import { tv } from 'tailwind-variants';

const colorSwatchStyles = tv({
    base: `
    iris:inline-block
    iris:rounded-(--base-size-radius-rounded)
    iris:shadow-[inset_0_0_0_var(--comp-size-border-color-swatch)_var(--comp-color-border-color-swatch-default)]
  `,
    variants: {
        variant: {
            beige: `
        iris:bg-[radial-gradient(141.4%_141.4%_at_0%_0%,var(--comp-color-background-color-swatch-beige-light)_60%,var(--comp-color-background-color-swatch-beige-dark)_100%)]
      `,
            black: `
        iris:bg-[radial-gradient(141.4%_141.4%_at_0%_0%,var(--comp-color-background-color-swatch-black-light)_60%,var(--comp-color-background-color-swatch-black-dark)_100%)]
      `,
            blue: `
        iris:bg-[radial-gradient(141.4%_141.4%_at_0%_0%,var(--comp-color-background-color-swatch-blue-light)_60%,var(--comp-color-background-color-swatch-blue-dark)_100%)]
      `,
            brown: `
        iris:bg-[radial-gradient(141.4%_141.4%_at_0%_0%,var(--comp-color-background-color-swatch-brown-light)_60%,var(--comp-color-background-color-swatch-brown-dark)_100%)]
      `,
            burgundy: `
        iris:bg-[radial-gradient(141.4%_141.4%_at_0%_0%,var(--comp-color-background-color-swatch-burgundy-light)_60%,var(--comp-color-background-color-swatch-burgundy-dark)_100%)]
      `,
            charcoal: `
        iris:bg-[radial-gradient(141.4%_141.4%_at_0%_0%,var(--comp-color-background-color-swatch-charcoal-light)_60%,var(--comp-color-background-color-swatch-charcoal-dark)_100%)]
      `,
            gold: `
        iris:bg-[radial-gradient(141.4%_141.4%_at_0%_0%,var(--comp-color-background-color-swatch-gold-light)_60%,var(--comp-color-background-color-swatch-gold-dark)_100%)]
      `,
            gray: `
        iris:bg-[radial-gradient(141.4%_141.4%_at_0%_0%,var(--comp-color-background-color-swatch-gray-light)_60%,var(--comp-color-background-color-swatch-gray-dark)_100%)]
      `,
            green: `
        iris:bg-[radial-gradient(141.4%_141.4%_at_0%_0%,var(--comp-color-background-color-swatch-green-light)_60%,var(--comp-color-background-color-swatch-green-dark)_100%)]
      `,
            offwhite: `
        iris:bg-[radial-gradient(141.4%_141.4%_at_0%_0%,var(--comp-color-background-color-swatch-offwhite-light)_60%,var(--comp-color-background-color-swatch-offwhite-dark)_100%)]
      `,
            orange: `
        iris:bg-[radial-gradient(141.4%_141.4%_at_0%_0%,var(--comp-color-background-color-swatch-orange-light)_60%,var(--comp-color-background-color-swatch-orange-dark)_100%)]
      `,
            pink: `
        iris:bg-[radial-gradient(141.4%_141.4%_at_0%_0%,var(--comp-color-background-color-swatch-pink-light)_60%,var(--comp-color-background-color-swatch-pink-dark)_100%)]
      `,
            purple: `
        iris:bg-[radial-gradient(141.4%_141.4%_at_0%_0%,var(--comp-color-background-color-swatch-purple-light)_60%,var(--comp-color-background-color-swatch-purple-dark)_100%)]
      `,
            red: `
        iris:bg-[radial-gradient(141.4%_141.4%_at_0%_0%,var(--comp-color-background-color-swatch-red-light)_60%,var(--comp-color-background-color-swatch-red-dark)_100%)]
      `,
            silver: `
        iris:bg-[radial-gradient(141.4%_141.4%_at_0%_0%,var(--comp-color-background-color-swatch-silver-light)_60%,var(--comp-color-background-color-swatch-silver-dark)_100%)]
      `,
            tan: `
        iris:bg-[radial-gradient(141.4%_141.4%_at_0%_0%,var(--comp-color-background-color-swatch-tan-light)_60%,var(--comp-color-background-color-swatch-tan-dark)_100%)]
      `,
            turquoise: `
        iris:bg-[radial-gradient(141.4%_141.4%_at_0%_0%,var(--comp-color-background-color-swatch-turquoise-light)_60%,var(--comp-color-background-color-swatch-turquoise-dark)_100%)]
      `,
            white: `
        iris:bg-[radial-gradient(141.4%_141.4%_at_0%_0%,var(--comp-color-background-color-swatch-white-light)_60%,var(--comp-color-background-color-swatch-white-dark)_100%)]
      `,
            yellow: `
        iris:bg-[radial-gradient(141.4%_141.4%_at_0%_0%,var(--comp-color-background-color-swatch-yellow-light)_60%,var(--comp-color-background-color-swatch-yellow-dark)_100%)]
      `,
        },
    },
});

export { colorSwatchStyles };
